export class VirtualClinicAnalysisFilterIges {

    public static fromObject(obj: any = {}): VirtualClinicAnalysisFilterIges {
        return new VirtualClinicAnalysisFilterIges(
            obj.einschlussKriterien ?? null,
            obj.k1DrgStationaer ?? null,
            obj.k2OpsStationaer ?? null,
            obj.k3StationaereBehandlungBeatmung ?? null,
            obj.k5IcdBetreuungsbedarf ?? null,
            obj.k6IcdStationaer ?? null,
            obj.k6sErhoehterAufwand ?? null,
            obj.k7Pccl ?? null,
            obj.k8Pflegegrade ?? null,
            obj.kSharpAlter ?? null
        );
    }

    constructor(
        private _einschlussKriterien: boolean | null,
        private _k1DrgStationaer: boolean | null,
        private _k2OpsStationaer: boolean | null,
        private _k3StationaereBehandlungBeatmung: boolean | null,
        private _k5IcdBetreuungsbedarf: boolean | null,
        private _k6IcdStationaer: boolean | null,
        private _k6sErhoehterAufwand: boolean | null,
        private _k7Pccl: boolean | null,
        private _k8Pflegegrade: boolean | null,
        private _kSharpAlter: boolean | null
    ) {
    }

    public clone(): VirtualClinicAnalysisFilterIges {
        return new VirtualClinicAnalysisFilterIges(
            this._einschlussKriterien,
            this._k1DrgStationaer,
            this._k2OpsStationaer,
            this._k3StationaereBehandlungBeatmung,
            this._k5IcdBetreuungsbedarf,
            this._k6IcdStationaer,
            this._k6sErhoehterAufwand,
            this._k7Pccl,
            this._k8Pflegegrade,
            this._kSharpAlter
        );
    }

    public equals(toCompare: VirtualClinicAnalysisFilterIges): boolean {
        return !!toCompare &&
            this._einschlussKriterien === toCompare._einschlussKriterien &&
            this._k1DrgStationaer === toCompare.k1DrgStationaer &&
            this._k2OpsStationaer === toCompare.k2OpsStationaer &&
            this._k3StationaereBehandlungBeatmung === toCompare.k3StationaereBehandlungBeatmung &&
            this._k5IcdBetreuungsbedarf === toCompare.k5IcdBetreuungsbedarf &&
            this._k6IcdStationaer === toCompare.k6IcdStationaer &&
            this._k6sErhoehterAufwand === toCompare.k6sErhoehterAufwand &&
            this._k7Pccl === toCompare.k7Pccl &&
            this._k8Pflegegrade === toCompare.k8Pflegegrade &&
            this._kSharpAlter === toCompare.kSharpAlter;
    }

    public toJSON(): any {
        return {
            einschlussKriterien: this._einschlussKriterien,
            k1DrgStationaer: this._k1DrgStationaer,
            k2OpsStationaer: this._k2OpsStationaer,
            k3StationaereBehandlungBeatmung: this._k3StationaereBehandlungBeatmung,
            k5IcdBetreuungsbedarf: this._k5IcdBetreuungsbedarf,
            k6IcdStationaer: this._k6IcdStationaer,
            k6sErhoehterAufwand: this._k6sErhoehterAufwand,
            k7Pccl: this._k7Pccl,
            k8Pflegegrade: this._k8Pflegegrade,
            kSharpAlter: this._kSharpAlter
        };
    }


    get einschlussKriterien(): boolean | null {
        return this._einschlussKriterien;
    }

    set einschlussKriterien(value: boolean | null) {
        this._einschlussKriterien = value;
    }

    get k1DrgStationaer(): boolean | null {
        return this._k1DrgStationaer;
    }

    set k1DrgStationaer(value: boolean | null) {
        this._k1DrgStationaer = value;
    }

    get k2OpsStationaer(): boolean | null {
        return this._k2OpsStationaer;
    }

    set k2OpsStationaer(value: boolean | null) {
        this._k2OpsStationaer = value;
    }

    get k3StationaereBehandlungBeatmung(): boolean | null {
        return this._k3StationaereBehandlungBeatmung;
    }

    set k3StationaereBehandlungBeatmung(value: boolean | null) {
        this._k3StationaereBehandlungBeatmung = value;
    }

    get k6IcdStationaer(): boolean | null {
        return this._k6IcdStationaer;
    }

    set k6IcdStationaer(value: boolean | null) {
        this._k6IcdStationaer = value;
    }

    get k5IcdBetreuungsbedarf(): boolean | null {
        return this._k5IcdBetreuungsbedarf;
    }

    set k5IcdBetreuungsbedarf(value: boolean | null) {
        this._k5IcdBetreuungsbedarf = value;
    }

    get k8Pflegegrade(): boolean | null {
        return this._k8Pflegegrade;
    }

    set k8Pflegegrade(value: boolean | null) {
        this._k8Pflegegrade = value;
    }

    get k6sErhoehterAufwand(): boolean | null {
        return this._k6sErhoehterAufwand;
    }

    set k6sErhoehterAufwand(value: boolean | null) {
        this._k6sErhoehterAufwand = value;
    }


    get kSharpAlter(): boolean | null {
        return this._kSharpAlter;
    }

    set kSharpAlter(value: boolean | null) {
        this._kSharpAlter = value;
    }

    get k7Pccl(): boolean | null {
        return this._k7Pccl;
    }

    set k7Pccl(value: boolean | null) {
        this._k7Pccl = value;
    }
}
